/**
 * Utility functions for order calculations
 */

/**
 * Calculate if an order is late based on its date and status
 * Orders in "Para fazer" or "Aguardando Material" status for more than 7 days are considered late
 * @param {Object} order - The order object
 * @param {string} order.dataPedido - Order date in ISO format (YYYY-MM-DD)
 * @param {string} order.statusOperacao - Order status
 * @returns {boolean} - True if the order is late
 */
export const isOrderLate = (order) => {
  // Only check for late orders in specific statuses
  const lateStatuses = ['Para fazer', 'Aguardando Material'];
  
  if (!lateStatuses.includes(order.statusOperacao)) {
    return false;
  }

  if (!order.dataPedido) {
    return false;
  }

  const orderDate = new Date(order.dataPedido);
  const currentDate = new Date();
  const daysDifference = Math.floor((currentDate - orderDate) / (1000 * 60 * 60 * 24));

  return daysDifference > 7;
};

/**
 * Get the number of days an order has been in its current status
 * @param {Object} order - The order object
 * @param {string} order.dataPedido - Order date in ISO format (YYYY-MM-DD)
 * @returns {number} - Number of days since the order was created
 */
export const getOrderAgeInDays = (order) => {
  if (!order.dataPedido) {
    return 0;
  }

  const orderDate = new Date(order.dataPedido);
  const currentDate = new Date();
  return Math.floor((currentDate - orderDate) / (1000 * 60 * 60 * 24));
};

/**
 * Get a human-readable description of how late an order is
 * @param {Object} order - The order object
 * @returns {string} - Description of lateness (e.g., "3 dias atrasado", "1 dia atrasado")
 */
export const getLateOrderDescription = (order) => {
  if (!isOrderLate(order)) {
    return '';
  }

  const daysLate = getOrderAgeInDays(order) - 7;
  
  if (daysLate === 1) {
    return '1 dia atrasado';
  } else {
    return `${daysLate} dias atrasado`;
  }
};

